import {Component, computed, inject, input, OnInit} from '@angular/core';
import {OccupationZoneDeTravailDto} from '../../../dto/occupation-zone-de-travail.dto';
import {Router} from '@angular/router';
import {AuthService} from '../../../services/auth-service.service';
import {DateUtilsService} from '../../../services/date-utils.service';
import {TranslateService} from '@ngx-translate/core';

@Component({
	selector: 'app-jauge-occupation',
	templateUrl: './jauge-occupation.component.html',
	styleUrl: './jauge-occupation.component.scss'
})
export class JaugeOccupationComponent implements OnInit {

	private readonly COULEUR_JAUGE_80_POURCENT = '#789f4e';
	private readonly COULEUR_JAUGE_100_POURCENT = '#FFCE54';
	private readonly COULEUR_JAUGE_SUP_100_POURCENT = '#CC3D3D';

	private router = inject(Router);
	private authService = inject(AuthService);
	private dateUtilsService = inject(DateUtilsService);
	private translateService = inject(TranslateService);

	occupationZoneDeTravail = input.required<OccupationZoneDeTravailDto>();
	dateTauxOccupation = input.required<Date>();

	readonly plusGrandNombreUtilisateurPresent = computed(() => {
		const nombreUtilisateurEnPresentielJournee = this.occupationZoneDeTravail().nombreUtilisateurEnPresentielJournee;
		const nombreUtilisateurEnPresentielMatin = this.occupationZoneDeTravail().nombreUtilisateurEnPresentielMatin;
		const nombreUtilisateurEnPresentielApresMidi = this.occupationZoneDeTravail().nombreUtilisateurEnPresentielApresMidi;

		return Math.max(nombreUtilisateurEnPresentielJournee, nombreUtilisateurEnPresentielMatin, nombreUtilisateurEnPresentielApresMidi);
	});

	readonly tauxOccupationAvecIconePourcentage = computed(() => {
		return `${this.occupationZoneDeTravail().valeurTauxOccupation}%`;
	});

	readonly couleurJauge = computed(() => {
		const tauxOccupation = this.occupationZoneDeTravail().valeurTauxOccupation;

		if (tauxOccupation <= 80) {
			return this.COULEUR_JAUGE_80_POURCENT;
		}
		if (tauxOccupation > 80 && tauxOccupation < 100) {
			return this.COULEUR_JAUGE_100_POURCENT;
		}
		if (tauxOccupation === 100) {
			return this.COULEUR_JAUGE_SUP_100_POURCENT;
		}
	});

	readonly contenuTooltipOccupation = computed(() => {
		return this.translateService.instant('JAUGE_OCCUPATION.LABEL_TAUX_OCCUPATION', {
			nombreUtilisateurPresent: this.plusGrandNombreUtilisateurPresent(),
			nombrePlaceDisponible: this.occupationZoneDeTravail().nombrePlaceDisponible
		});
	});

	langue: string;

	ngOnInit(): void {
		this.langue = this.authService.getUtilisateurConnecte().langue;
	}

	onClickVoirEtatZoneDeTravail(): void {
		this.router.navigate(['/visionner-taux-occupation'], {
			queryParams: {
				date: this.dateUtilsService.formaterDateEnStringPourEnvoiBack(this.dateTauxOccupation(), this.langue)
			}
		});
	}
}
